var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.kioskMenuHeader },
    [
      _vm.isMenuHeader
        ? _c(
            "button",
            {
              class: [_vm.$style.kioskMenuBtn, _vm.$style.kioskExitBtn],
              on: { click: _vm.handleLogoClick }
            },
            [
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.headerMenuIcon,
                attrs: { symbol: "exit-icon" }
              })
            ]
          )
        : _c(
            "button",
            {
              class: _vm.$style.kioskMenuBtn,
              on: { click: _vm.handleMenuClick }
            },
            [
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.headerMenuIcon,
                attrs: { symbol: "menu-icon" }
              }),
              _vm._v(" Menu\n  ")
            ]
          ),
      _vm._v(" "),
      _c("img", {
        attrs: { src: require("@/assets/img/white.png"), alt: "Burger Boss" },
        on: { click: _vm.handleLogoClick }
      }),
      _vm._v(" "),
      _c("KioskCartIcon")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskMenuHeader.vue?vue&type=template&id=fab7ea54&
// module id = null
// module chunks = 